import Vue from 'vue';
import './directive';

import {
  Button,
  ButtonLine,
  Cell,
  CellLeft,
  CellRight,
  Box,
  Toggle,
  Checkbox,
  SuspendMenu,
} from '@mx/vix';

[
  Button,
  ButtonLine,
  Cell,
  CellLeft,
  CellRight,
  Box,
  Toggle,
  Checkbox,
  SuspendMenu,
].map((c) => Vue.use(c));

export * from './env';
export * from './api';
export * from './bridge';
export * from './monitor';
export * from './event-hub';
